import * as _ from "lodash";
import * as angular from "angular";
import { EventModel } from "../../models/event.model";

let EventListComponent = {
    selector: "vcEventList",
    templateUrl: "/angular/components/event/event-list.component.html",
    bindings: {
        events: "=?",
        order: "=?",
    },
    controller: class EventListController {
        // * bindings for typescript compiler *
        public events?: any;
        public order?: any;
        // ************************************

        public direction: string;
        public filterOrderBy: string;
        public orderedEvents: any = [];
        public groupEvent: any;

        private $scope: any;

        constructor($scope: any) {
            this.$scope = $scope;
        }

        $onInit() {
            this.order = this.order ? this.order : "asc";
            this.direction = this.order === "asc" ? "+" : "-";
            this.filterOrderBy = this.direction + this.order;

            this.$scope.$watch(
                () => this.events,
                () => {
                    angular.forEach(this.events, (event: EventModel) => {
                        event.groupdate =
                            event.starttimestamp.substring(0, 7) + "-01";
                    });

                    this.orderedEvents = _.orderBy(
                        this.events,
                        ["starttimestamp"],
                        [this.order]
                    );
                    this.groupEvent = _.groupBy(
                        this.orderedEvents,
                        "groupdate"
                    );
                },
                true
            );
        }
    },
};

angular
    .module("event")
    .component(EventListComponent.selector, EventListComponent);
